import { get } from './client';

export function getFeatureFlags() {
  return get('/feature-flags');
}

export function getCurrentVersion() {
  return get('/environment').then((environment) => environment.uiVersion);
}
